// Функція для визначення мобільного пристрою
const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        window.innerWidth <= 768;
};

// Функція для отримання оптимального hfov залежно від пристрою
const getOptimalHfov = () => {
    return isMobileDevice() ? 60 : 110;
};

// Конфігурація віртуального туру
export const tourConfig = {
    default: {
        firstScene: "318-part1",
        author: "Віртуальний тур",
        sceneFadeDuration: 1000,
        autoLoad: true,
    },

    scenes: {
        // Аудиторія 04 (2 частини)
        "04-part1": {
            title: "Лабораторія гідравліки - Стенди",
            hfov: 110,
            pitch: -3,
            yaw: 270,
            type: "equirectangular",
            panorama: "/tour/04-part2.JPG",
            hotSpots: [
                {
                    pitch: -10.1,
                    yaw: 35.5,
                    type: "scene",
                    text: "Повернутись до основної частини",
                    sceneId: "04-part2",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -20.4,
                    yaw: 220.1,
                    type: "info",
                    title: "Гідравлічні стенди",
                    content: "Ця лабораторія оснащена навчальними гідравлічними стендами, що дозволяють досліджувати гідравлічні процеси та відпрацьовувати практичні навички. Студенти можуть моделювати роботу гідравлічних систем, аналізувати їхні параметри та вивчати принципи роботи різноманітних гідравлічних компонентів у реальних умовах.",
                    cssClass: "info-hotspot",
                },
            ],
        },

        "04-part2": {
            title: "Лабораторія гідравліки - Аудиторія",
            hfov: 110,
            pitch: -3,
            yaw: 187,
            type: "equirectangular",
            panorama: "/tour/04-part1.JPG",
            hotSpots: [
                {
                    pitch: -2.1,
                    yaw: 192.9,
                    type: "scene",
                    text: "Перейти до стендів",
                    sceneId: "04-part1",
                    cssClass: "scene-hotspot",
                },
            ],
        },

        // Аудиторія 05 (1 частина)
        "05": {
            title: "Аудиторія 05",
            hfov: 110,
            pitch: -3,
            yaw: 217,
            type: "equirectangular",
            panorama: "/tour/05.JPG",
            hotSpots: [
                {
                    pitch: -0.9,
                    yaw: 235.8,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: "Ця лабораторія спеціалізується на роботі з компресорним обладнанням та навчальними стендами з компресорами. Тут також є мультимедійний проєктор для демонстрацій та пояснень під час занять. Основна спрямованість лабораторії — проведення практичних занять і лабораторних робіт з гідравліки та компресорних систем, що дозволяє студентам наочно вивчати принципи роботи та особливості експлуатації такого обладнання.",
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 06-1 (окрема лабораторія)
        "06-part1": {
            title: "Лабораторія гідравлічного обладнання (06-1)",
            hfov: 110,
            pitch: -5,
            yaw: 235.8,
            type: "equirectangular",
            panorama: "/tour/06-part1.JPG",
            hotSpots: [
                // {
                //     pitch: -2.1,
                //     yaw: 60.9,
                //     type: "scene",
                //     text: "Перейти до частини 2",
                //     sceneId: "06-part2",
                //     cssClass: "scene-hotspot",
                // },
                {
                    pitch: -10,
                    yaw: 205.8,
                    type: "info",
                    title: "Навчальні стенди",
                    content: "Простір оснащений численними навчальними стендами для проведення лабораторних робіт, які були створені самими студентами, що робить процес навчання ще більш практичним і наочним. Лабораторія дозволяє поєднувати теоретичні знання з практичним досвідом у сфері гідравліки та механіки.",
                    cssClass: "info-hotspot",
                },
                {
                    pitch: -13,
                    yaw: 375.8,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: "Ця лабораторія демонструє різноманітне гідравлічне обладнання у розрізі — компресори, насоси, циліндри та інші вузли, що дозволяє наочно вивчати принципи їхньої роботи та конструкцію.",
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 06-2 (окрема лабораторія)
        "06-part2": {
            title: "Лабораторія маніпуляторів та промислового обладнання (06-2)",
            hfov: 110,
            pitch: -10,
            yaw: 210,
            type: "equirectangular",
            panorama: "/tour/06-part2.JPG",
            hotSpots: [
                // {
                //     pitch: -10.1,
                //     yaw: 100.5,
                //     type: "scene",
                //     text: "Повернутись до основної частини",
                //     sceneId: "06-part1",
                //     cssClass: "scene-hotspot",
                // },
                {
                    pitch: -20.4,
                    yaw: 204.5,
                    type: "info",
                    title: "Колаборативний робот (cobot)",
                    content: `Це колаборативний робот, або cobot — маніпулятор, який може працювати поруч із людиною без повноцінних захисних огорож. Він використовується для точних і повторюваних операцій у лабораторіях та дослідницьких середовищах. Робот має 6 ступенів свободи, що дозволяє йому виконувати складні рухи в просторі. Часто застосовується для автоматизації експериментів, роботи з інструментами та навчальних задач.`,
                    cssClass: "info-hotspot",
                },
                {
                    pitch: -20.4,
                    yaw: 328.5,
                    type: "info",
                    title: "Робот-собака Go2 (інтелектуальний квадропед)",
                    content: `Go2 — це сучасний чотириногий робот, який імітує рухи собаки та використовується для досліджень, демонстрацій і автономної навігації.
                    Він оснащений камерами, сенсорами та системами штучного інтелекту для орієнтації в просторі та обходу перешкод.
                    Завдяки динамічній кінематиці робот може бігати, ходити по нерівних поверхнях і утримувати рівновагу.
                    Його застосовують у робототехніці, освіті, інспекційних задачах і тестуванні алгоритмів автономного руху.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 08 (Лабораторія аеродинаміки)
        "08": {
            title: "Лабораторія аеродинаміки (08)",
            hfov: 110,
            pitch: -10,
            yaw: 0,
            type: "equirectangular",
            panorama: "/tour/08.JPG",
            hotSpots: [
                {
                    pitch: -5,
                    yaw: 30,
                    type: "info",
                    title: "Аеротруба",
                    content: `Аеротруба — це експериментальна установка, призначена для дослідження аеродинамічних характеристик об'єктів у контрольованих умовах повітряного потоку. Вона дозволяє моделювати обтікання тіл повітрям, вимірювати аеродинамічні сили та моменти, а також візуалізувати потоки за допомогою спеціальних методів.

Аеротруби використовуються в авіаційній, автомобільній промисловості, будівництві та інших галузях для тестування моделей літаків, автомобілів, будівель та інших конструкцій перед їх виробництвом або будівництвом.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 120 (2 частини)
        "120-part1": {
            title: "Лабораторія автоматизації (120) - Частина 1",
            hfov: 110,
            pitch: -20,
            yaw: 250,
            type: "equirectangular",
            panorama: "/tour/120-part1.JPG",
            hotSpots: [
                {
                    pitch: -15,
                    yaw: 235,
                    type: "scene",
                    text: "Змінити кут огляду",
                    sceneId: "120-part2",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -25,
                    yaw: 250,
                    type: "info",
                    title: "Franka Emika Panda — колаборативний робот (cobot)",
                    content: `Це робот-маніпулятор з 7 ступенями свободи, розроблений для безпечної взаємодії з людиною.
                    Він має вантажопідйомність до 3 кг і робочу зону з радіусом до 850 мм.
                    Завдяки вбудованим датчикам крутного моменту в кожному суглобі робот забезпечує точне та “м’яке” керування рухами.
                    Використовується в дослідженнях, навчанні та задачах, що потребують високої точності та безпечної взаємодії з оператором.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        "120-part2": {
            title: "Лабораторія автоматизації (120) - Частина 2",
            hfov: 110,
            pitch: -20,
            yaw: 200,
            type: "equirectangular",
            panorama: "/tour/120-part2.JPG",
            hotSpots: [
                {
                    pitch: -15,
                    yaw: 220,
                    type: "scene",
                    text: "Змінити кут огляду",
                    sceneId: "120-part1",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -10,
                    yaw: 200,
                    type: "info",
                    title: "Stäubli TS60 — промисловий SCARA робот-маніпулятор",
                    content: `Це високошвидкісний промисловий робот типу SCARA, призначений для точних і повторюваних операцій у виробництві.
                    Має 4 осі руху, що забезпечує оптимальну швидкість і стабільність при виконанні задач у горизонтальній площині.
                    Використовується для складання деталей, пакування, обробки матеріалів та контролю якості.
                    Завдяки високій точності та надійності широко застосовується в автоматизованих виробничих лініях.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 126 (2 частини)
        "126-part1": {
            title: "Аудиторія 126 - Частина 1",
            hfov: 110,
            pitch: -15,
            yaw: 200,
            type: "equirectangular",
            panorama: "/tour/126-part1.JPG",
            hotSpots: [
                {
                    pitch: -20.1,
                    yaw: 202.9,
                    type: "scene",
                    text: "Перейти до стендів",
                    sceneId: "126-part2",
                    cssClass: "scene-hotspot",
                },
            ],
        },

        "126-part2": {
            title: "Аудиторія 126 - Частина 2",
            hfov: 110,
            pitch: -30,
            yaw: 200,
            type: "equirectangular",
            panorama: "/tour/126-part2.JPG",
            hotSpots: [
                {
                    pitch: 5.1,
                    yaw: 200,
                    type: "scene",
                    text: "Повернутись до основної частини",
                    sceneId: "126-part1",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -20.4,
                    yaw: 250.1,
                    type: "info",
                    title: "Обладнання",
                    content: `У цій лабораторії представлено пневматичні стенди, що моделюють реальні виробничі процеси та системи автоматизації підприємств. Це не окремі елементи для складання схем, а готові навчальні комплекси — міні-системи, які відтворюють роботу автоматизованих вузлів і дозволяють досліджувати принципи функціонування промислового обладнання в умовах, наближених до реальних. Додатково передбачено окремий стенд для самостійного складання пневматичних схем і відпрацювання різних варіантів керування.

                    Лабораторія також оснащена сучасними комп’ютерами, на яких проводяться заняття з робототехніки та промислової автоматизації. Тут використовується програмне забезпечення для моделювання й програмування промислових роботів KUKA на ліцензійному програмному забезпеченні, що дозволяє студентам проєктувати роботизовані системи, відпрацьовувати траєкторії руху та моделювати роботу виробничих ліній у віртуальному середовищі.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 299-05 (1 частина)
        "299-05": {
            title: "Аудиторія 299-05",
            hfov: 110,
            pitch: -10,
            yaw: 230,
            type: "equirectangular",
            panorama: "/tour/299-05.JPG",
            hotSpots: [
                {
                    pitch: -0.9,
                    yaw: 220,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: `Ця лабораторія функціонує насамперед як сучасний комп’ютерний клас, оснащений новими потужними комп’ютерами та мультимедійним проєктором. Тут проводяться заняття з дисциплін, що передбачають використання CAD-систем, середовищ моделювання та інженерного аналізу, зокрема MATLAB для візуалізації, симуляції та дослідження процесів.

                    Окрім цього, в лабораторії відбуваються практичні заняття з основ програмування та роботи з мікроконтролерами, зокрема платформою Arduino. Студенти збирають електронні схеми, програмують пристрої та тестують їх у реальному часі. Також у приміщенні розміщені макети об’ємних гідромашин, що використовуються для навчальних демонстрацій і поглибленого вивчення принципів їх роботи.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 299-06 (1 частина)
        "299-06": {
            title: "Аудиторія 299-06",
            hfov: 110,
            pitch: -15,
            yaw: 217,
            type: "equirectangular",
            panorama: "/tour/299-06.JPG",
            hotSpots: [
                {
                    pitch: -0.9,
                    yaw: 235.8,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: `Ця лабораторія оснащена навчальними стендами для складання електричних схем і відпрацювання основ електротехніки. У ній представлено велику кількість комплектуючих та модулів, що дозволяють збирати різноманітні електричні кола, досліджувати їхню роботу та проводити вимірювання основних параметрів.

                    Окрім цього, в лабораторії розміщені зразки пневмоапаратури в розрізі, що дає можливість наочно вивчати внутрішню будову та принцип дії обладнання. Простір використовується для формування базових практичних навичок роботи з електричними схемами та технічними елементами.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 300-01 (2 частини)
        "300-01-part1": {
            title: "Аудиторія 300-01 - Частина 1",
            hfov: 110,
            pitch: -3,
            yaw: 117,
            type: "equirectangular",
            panorama: "/tour/300-01-part1.JPG",
            hotSpots: [
                {
                    pitch: -2.1,
                    yaw: 132.9,
                    type: "scene",
                    text: "Перейти до частини стендів",
                    cssClass: "scene-hotspot",
                    sceneId: "300-01-part2",
                },
            ],
        },

        "300-01-part2": {
            title: "Аудиторія 300-01 - Частина 2",
            hfov: 110,
            pitch: -15,
            yaw: 200,
            type: "equirectangular",
            panorama: "/tour/300-01-part2.JPG",
            hotSpots: [
                {
                    pitch: -14.1,
                    yaw: 100.5,
                    type: "scene",
                    text: "Повернутись до основної частини",
                    sceneId: "300-01-part1",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -13.9,
                    yaw: 225.8,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: `Пневматичні стенди для цієї лабораторії були надані компанією Festo. Простір оснащений великою кількістю навчальних стендів, призначених для вивчення та моделювання пневматичних систем різної складності.

                    У лабораторії використовуються пневмоциліндри різних типів, дво- та трипозиційні розподільники, лінійні напрямні, клапани затримки часу, регулятори та клапани тиску, а також інші елементи пневмоавтоматики. Обладнання дозволяє збирати та досліджувати як базові, так і більш складні пневматичні схеми.

                    Передбачена можливість підключення електрокерування, що дає змогу реалізовувати електропневматичні системи, відпрацьовувати алгоритми керування та досліджувати принципи автоматизації технологічних процесів.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 300-02 (1 частина)
        "300-02": {
            title: "Аудиторія 300-02",
            hfov: 110,
            pitch: -3,
            yaw: 187,
            type: "equirectangular",
            panorama: "/tour/300-02.JPG",
            hotSpots: [
                {
                    pitch: -0.9,
                    yaw: 150.8,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: `Ця лабораторія оснащена численними навчальними стендами для складання та дослідження гідравлічних і гідравлічно-електричних схем, тобто систем гідравліки з електричним керуванням. Вона призначена для моделювання реальних промислових процесів і відпрацювання принципів автоматизації.

                    У лабораторії використовуються гідроциліндри різних типів, розподільники, регулювальні та запобіжні клапани, гідромотори й інші виконавчі елементи. Системи можуть доповнюватися електричними модулями керування, датчиками положення та тиску, вимірювальними приладами й навчальними контролерами.

                    Таке оснащення дозволяє студентам не лише складати схеми, а й аналізувати роботу гідравлічних систем, досліджувати параметри тиску та витрати, відпрацьовувати логіку керування й набувати практичних навичок роботи з сучасним промисловим обладнанням.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        // Аудиторія 318 (2 частини) - СТАРТОВА
        "318-part1": {
            title: "Аудиторія 318 - Частина 1",
            hfov: 110,
            pitch: -15,
            yaw: 210,
            type: "equirectangular",
            panorama: "/tour/318-part1.JPG",
            hotSpots: [
                {
                    pitch: -3.1,
                    yaw: 112.9,
                    type: "scene",
                    text: "Перейти до частини 2",
                    sceneId: "318-part2",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -0.9,
                    yaw: 230.8,
                    type: "info",
                    title: "Обладнання аудиторії",
                    content: `Лабораторія створена за підтримки компанії Ajax Systems та обладнана сучасними 3D-принтерами, верстатами й наборами інструментів для реалізації інженерних і творчих проєктів.

                    Простір використовується для практичних занять, роботи гуртків і власних ініціатив студентів. Є можливість попередньо записатися та отримати доступ до обладнання для реалізації власних ідей.`,
                    cssClass: "info-hotspot",
                },
            ],
        },

        "318-part2": {
            title: "Аудиторія 318 - Частина 2",
            hfov: 110,
            pitch: -15,
            yaw: 230,
            type: "equirectangular",
            panorama: "/tour/318-part2.JPG",
            hotSpots: [
                {
                    pitch: -14.1,
                    yaw: -40,
                    type: "scene",
                    text: "Повернутись до частини 1",
                    sceneId: "318-part1",
                    cssClass: "scene-hotspot",
                },
                {
                    pitch: -20.4,
                    yaw: 230.1,
                    type: "info",
                    title: "Обладнання",
                    content: "Ця частина лабораторії обладнана сучасними потужними комп’ютерами та мультимедійним проєктором, що забезпечують комфортні умови для проведення практичних занять, демонстрацій і презентацій. Простір пристосований для роботи з інженерним програмним забезпеченням, моделюванням і колективного обговорення проєктів.",
                    cssClass: "info-hotspot",
                },
            ],
        },
    },
};

// Конфігурація лабораторій
export const labConfig = {
    "318": {
        name: "Лабораторія машинобудування та робототехніки (318)",
        startScene: "318-part1",
    },
    "300-01": {
        name: "Лабораторія пневмоавтоматики (300-01)",
        startScene: "300-01-part1",
    },
    "300-02": {
        name: "Лабораторія 300-02",
        startScene: "300-02",
    },
    "299-05": {
        name: "Лабораторія об'ємних гідромашин (299-05)",
        startScene: "299-05",
    },
    "299-06": {
        name: "Аудиторія 299-06",
        startScene: "299-06",
    },
    "126": {
        name: "Лабораторія механотроніки (126)",
        startScene: "126-part1",
    },
    "08": {
        name: "Лабораторія аеродинаміки (08)",
        startScene: "08",
    },
    "120": {
        name: "Лабораторія автоматизації (120)",
        startScene: "120-part2",
    },
    "06-1": {
        name: "Лабораторія гідравлічного обладнання (06-1)",
        startScene: "06-part1",
    },
    "06-2": {
        name: "Лабораторія маніпуляторів та промислового обладнання (06-2)",
        startScene: "06-part2",
    },
    "05": {
        name: "Лабораторія компресорних машин (05)",
        startScene: "05",
    },
    "04": {
        name: "Лабораторія гідравліки (04)",
        startScene: "04-part1",
    },
};

// Функція для отримання конфігурації з динамічним hfov
export const getTourConfig = () => {
    const optimalHfov = getOptimalHfov();

    // Створюємо копію конфігурації з оновленими hfov значеннями
    const dynamicConfig = JSON.parse(JSON.stringify(tourConfig));

    // Оновлюємо hfov для всіх сцен
    Object.keys(dynamicConfig.scenes).forEach(sceneKey => {
        dynamicConfig.scenes[sceneKey].hfov = optimalHfov;
    });

    return dynamicConfig;
};
